export default __webpack_public_path__ + "static/media/schedule-social-media-posts.50aa2cf3.svg";